import React from 'react';

import { Formik, Form as FormikForm } from 'formik';

import { Button, Modal } from '@shared/components/bootstrap';
import { FormikInputFormGroup } from '@shared/components/fields/formik/formik_input_form_group';
import { FormikSelectFormGroup } from '@shared/components/fields/formik/formik_select_form_group';

import { Landing__Location__ContentInput, Landing__Location__ReviewInput } from '@admin/schema';

const DEFAULT_RATING = 5;

export const LandingLocationReviewModal: React.FC<{
  review?: Landing__Location__ReviewInput;
  onClose(): void;
  onSave(input: Landing__Location__ReviewInput): void;
}> = ({ review, onClose, onSave }) => {
  const onSubmit = (input: Landing__Location__ReviewInput) => {
    if (!input.author || !input.message) return;
    onSave(input);
  };

  return (
    <Modal onClose={onClose}>
      <Formik<Landing__Location__ReviewInput>
        initialValues={{
          author: review?.author ?? '',
          message: review?.message ?? '',
          rating: review?.rating ?? DEFAULT_RATING,
        }}
        onSubmit={onSubmit}
      >
        <FormikForm>
          <Modal.Content>
            <Modal.Header>
              <Modal.Title>Review</Modal.Title>
              <Modal.Close close={onClose} />
            </Modal.Header>
            <Modal.Body>
              <FormikInputFormGroup id="author" name="author" label="Author:" />
              <FormikInputFormGroup id="message" name="message" label="Message:" />
              <FormikSelectFormGroup id="rating" name="rating" label="Rating:">
                {Array.from({ length: 5 }).map((_, index) => (
                  <option key={index} value={index + 1}>
                    {index + 1} Star(s)
                  </option>
                ))}
              </FormikSelectFormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" kind="primary">
                Save
              </Button>
            </Modal.Footer>
          </Modal.Content>
        </FormikForm>
      </Formik>
    </Modal>
  );
};
